export default __webpack_public_path__ + "static/media/5.2c075aea.jpeg";